
export const decodeBooleanParameter = <T>(value: undefined | string, fallback: T): T | boolean => {
  return value === 'true' ? true : fallback;
};
